import { render } from "./NodeDetailsWindow.vue?vue&type=template&id=5739990c"
import script from "./NodeDetailsWindow.vue?vue&type=script&lang=js"
export * from "./NodeDetailsWindow.vue?vue&type=script&lang=js"

import "./NodeDetailsWindow.vue?vue&type=style&index=0&id=5739990c&lang=scss"

import exportComponent from "/Users/tirinox/Projects/thorviz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__